// let log = []
let activeConnections = 0
let lastFail = new Date()
let lastSuccess = new Date()
let status = {
  working: false,
  healthy: true
}

function start () {
  // let timestamp = new Date()
  activeConnections++
  refreshStatus()
  // log.push({ timestamp, type: 'start', args: arguments })
}

function success () {
  let timestamp = new Date()
  lastSuccess = timestamp
  activeConnections--
  refreshStatus()
  // log.push({ timestamp, type: 'success', args: arguments })
}

function fail () {
  let timestamp = new Date()
  lastFail = timestamp
  activeConnections--
  refreshStatus()
  // log.push({ timestamp, type: 'fail', args: arguments })
}

function getStatus () {
  refreshStatus()
  return status
}

function refreshStatus () {
  status.working = activeConnections > 0
  status.healthy = lastSuccess >= lastFail
}

export default {
  start,
  success,
  fail,
  getStatus
}
